import { PageLayout } from 'coreOld/components';
import { CompanyPartsPage } from 'partsOld/pages';

import {
  companyConfiguratorsPath,
  companyElementsPath,
  companyPartsPath,
  configuratorsPath,
  elementsPath,
  manufacturersPath,
} from './routePaths';

export const elements = {
  path: elementsPath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Element Templates"></PageLayout>,
};

export const configurators = {
  path: configuratorsPath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Configurators"></PageLayout>,
};

export const manufacturers = {
  path: manufacturersPath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Manufacturers"></PageLayout>,
};

export const companyParts = {
  path: companyPartsPath(),
  exact: true,
  isPrivate: true,
  element: <CompanyPartsPage />,
};

export const companyElements = {
  path: companyElementsPath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Element Templates"></PageLayout>,
};

export const companyConfigurators = {
  path: companyConfiguratorsPath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Configurators"></PageLayout>,
};
